module.exports = __webpack_public_path__ + "img/userEquity7.0655c5bb.png";